// extracted by mini-css-extract-plugin
export default {"homeLayout":"HomeLayout_homeLayout__UNfpm","homeLayoutConnect":"HomeLayout_homeLayoutConnect__0x3ms"};